// Section 2 — Third-Party Partner Brand onboarding
// Outside brand / glassblower / artist. Distinct from `partner_store`
// (physical retailer) and from `partner_affiliate` (affiliate team lead).
import React from "react";
import PublicApply from "@/components/public/PublicApply";

export default function PartnerBrandSignup() {
  return (
    <PublicApply
      role="partner"
      roleTestId="partner-brand-signup"
      defaultBusinessCategory="product_brand"
      title="Bring your brand to Lifted."
      blurb="For independent brands, glassblowers, and artists. Upload your products, share your story, and get a dedicated shop section on Lifted. Admin approval required."
      extraFields={[
        { key: "partner_type", label: "Hidden partner type", placeholder: "brand", hidden: true, defaultValue: "brand" },
        { key: "brand_name", label: "Brand name", placeholder: "Higher Standard Glass" },
        { key: "brand_story", label: "Short brand story (optional)", placeholder: "One sentence on what makes your brand different." },
        { key: "instagram", label: "Instagram / social (optional)", placeholder: "@yourbrand" },
        { key: "website", label: "Website (optional)", placeholder: "https://" },
      ]}
    />
  );
}
